export const SDK_VERSION = '8.24.0';
